module.exports = __webpack_public_path__ + "img/Warm congratulations on the establishment of Guangzhou Weilin Co., Ltd. 220.c9e737ed.png";